export default function CArrayLoops() {
  return (
    <>
      <h2>C Array Loops</h2>;<h2>C Array Loops</h2>
    </>
  );
}
